/**
 * 系统错误日志枚举定义
 * 
 * @module types/error-log/enums
 * @description 定义错误日志系统的所有枚举类型
 * 
 * @backend-source
 * - backend/app/Modules/System/Models/ErrorLog.php (LEVEL_* 常量)
 * 
 * @attention
 * - 枚举值必须与后端完全一致（包括大小写）
 * - 每个枚举值都有对应的中文说明
 * 
 * @last-updated 2025-10-20
 */

/**
 * 错误级别枚举
 * 
 * 定义系统错误的严重程度分级
 * 
 * @backend ErrorLog::LEVEL_*
 */
export enum ErrorLevel {
  /** 紧急 - 系统不可用 */
  EMERGENCY = 'emergency',
  
  /** 警报 - 必须立即采取行动 */
  ALERT = 'alert',
  
  /** 严重 - 严重错误 */
  CRITICAL = 'critical',
  
  /** 错误 - 运行时错误 */
  ERROR = 'error',
  
  /** 警告 - 警告信息 */
  WARNING = 'warning',
  
  /** 注意 - 一般通知 */
  NOTICE = 'notice',
  
  /** 信息 - 信息消息 */
  INFO = 'info',
  
  /** 调试 - 调试信息 */
  DEBUG = 'debug',
}

/**
 * 运行环境枚举
 */
export enum Environment {
  /** 本地开发环境 */
  LOCAL = 'local',
  
  /** 测试环境 */
  TESTING = 'testing',
  
  /** 预发布环境 */
  STAGING = 'staging',
  
  /** 生产环境 */
  PRODUCTION = 'production',
}

